// import React from "react";
// import { motion } from "framer-motion";
// import "./CTASection.css";

// const CTASection = () => {
//   return (
//     <motion.section
//       className="cta-section"
//       initial={{ y: 50, opacity: 0 }}
//       whileInView={{ y: 0, opacity: 1 }}
//       viewport={{ once: false, amount: 0.3 }}
//       transition={{ type: "spring", stiffness: 100, damping: 20 }}
//     >
//       <div className="cta-container">
//         <motion.div
//           className="cta-btn"
//           initial={{ x: -50, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: false, amount: 0.3 }}
//           transition={{
//             type: "spring",
//             stiffness: 120,
//             damping: 20,
//             delay: 0.2,
//           }}
//         >
//           <div className="cta-text">
//             <h2 className="cta-heading">Plan Your Dream Journey with Us</h2>
//             <p>
//               Explore new destinations, create memories, and travel hassle-free
//               with our expert guidance.
//             </p>
//           </div>
//         </motion.div>

//         <motion.div
//           className="cta-btn"
//           initial={{ x: 50, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: false, amount: 0.3 }}
//           transition={{
//             type: "spring",
//             stiffness: 120,
//             damping: 20,
//             delay: 0.2,
//           }}
//         >
//           <a href="tel:+919876543210">Call Us Now</a>
//         </motion.div>
//       </div>
//     </motion.section>
//   );
// };

// export default CTASection;


import React from "react";
import { motion } from "framer-motion";
import "./CTASection.css";

const CTASection = ({
  heading = "Plan Your Dream Journey with Us",
  description = "Explore new destinations, create memories, and travel hassle-free with our expert guidance.",
  buttonText = "Call Us Now",
  buttonLink = "tel:+919876543210",
}) => {
  return (
    <motion.section
      className="cta-section"
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ type: "spring", stiffness: 100, damping: 20 }}
    >
      <div className="cta-container">
        
        {/* Left Content */}
        <motion.div
          className="cta-btn"
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{
            type: "spring",
            stiffness: 120,
            damping: 20,
            delay: 0.2,
          }}
        >
          <div className="cta-text">
            <h2 className="cta-heading">{heading}</h2>
            <p>{description}</p>
          </div>
        </motion.div>

        {/* Right Button */}
        <motion.div
          className="cta-btn"
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{
            type: "spring",
            stiffness: 120,
            damping: 20,
            delay: 0.2,
          }}
        >
          <a href={buttonLink}>{buttonText}</a>
        </motion.div>

      </div>
    </motion.section>
  );
};

export default CTASection;
